import PropTypes from "prop-types";
import { memo } from "react";
import { Box, Stack } from "@mui/material";
import NavList from "./NavList";
import { useAuthContext } from "src/auth/useAuthContext";

NavSectionMini.propTypes = {
  sx: PropTypes.object,
  data: PropTypes.array,
};

function NavSectionMini({ data, sx, ...other }) {
  const { user } = useAuthContext();

  let filteredData = data.map((group) => {
    let items = group.items;
    if (!user?.permissions?.canViewDashboard) {
      items = items.filter((item) => item.title !== "dashboard");
    }
    if (!user?.permissions?.canViewStaff) {
      items = items.filter((item) => item.title !== "staff");
    }
    if (!user?.permissions?.canAccessReports) {
      items = items.filter((item) => item.title !== "report");
    }

    if (!user?.permissions?.canViewVenueCustomers) {
      items = items.filter((item) => item.title !== "customers");
    }
    return { ...group, items };
  });
  return (
    <Stack
      spacing={0.5}
      alignItems="center"
      sx={{
        px: 0.75,
        ...sx,
      }}
      {...other}
    >
      {filteredData.map((group, index) => (
        <Items key={group.subheader} items={group.items} isLastGroup={index + 1 === data.length} />
      ))}
    </Stack>
  );
}

export default memo(NavSectionMini);

Items.propTypes = {
  items: PropTypes.array,
  isLastGroup: PropTypes.bool,
};

function Items({ items, isLastGroup }) {
  return (
    <>
      {items.map((list) => (
        <NavList key={list.title + list.path} data={list} depth={1} hasChild={!!list.children} />
      ))}

      {!isLastGroup && (
        <Box
          sx={{
            width: 24,
            height: "1px",
            bgcolor: "divider",
            my: "8px !important",
          }}
        />
      )}
    </>
  );
}
